import React from 'react';
import Navbar from '../landing/Navbar';
import Footer from '../landing/Footer';
import Seo from '../seo/Seo';

const PageShell = ({ title, seoTitle, seoDescription, seoPath, children }) => {
  return (
    <div className="min-h-screen bg-[#0B1220] text-[#F8FAFC]">
      <Seo
        title={seoTitle || `${title} | WealthDost`}
        description={
          seoDescription ||
          'WealthDost is India’s trust-first finance community for credible expert insights, real-time discussions, and investor tribes.'
        }
        path={seoPath}
      />
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-3xl sm:text-4xl font-bold mb-8">{title}</h1>
          <div className="prose prose-invert max-w-none">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PageShell;
